// Os oito tipos de NotificationType do proto-oversight-api, na íntegra.
export type NotificationStatus =
  | 'consent_approved'
  | 'consent_rejected'
  | 'consent_expiring'
  | 'approval_expiring'
  | 'consent_expired'
  | 'approval_expired'
  | 'session_ended_timeout'
  | 'session_ended_inactivity';

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info';

// Os chips filtram por status da delegação, não por tipo: o backend agrupa os
// tipos de cada status em TYPES_BY_STATUS.
export type NotificationFilterValue =
  | 'all'
  | 'pending_consent'
  | 'approved'
  | 'rejected'
  | 'expired'
  | 'ended';

export interface NotificationFilter {
  value: NotificationFilterValue;
  label: string;
}

export const notificationFilters: NotificationFilter[] = [
  { value: 'all', label: 'Tudo' },
  { value: 'pending_consent', label: 'Consentimento pendente' },
  { value: 'approved', label: 'Aprovada' },
  { value: 'expired', label: 'Expirada' },
  { value: 'rejected', label: 'Negada' },
  { value: 'ended', label: 'Encerrada' },
];

const notificationStatuses: NotificationStatus[] = [
  'consent_approved',
  'consent_rejected',
  'consent_expiring',
  'approval_expiring',
  'consent_expired',
  'approval_expired',
  'session_ended_timeout',
  'session_ended_inactivity',
];

export const getNotificationStatus = (
  type: string
): NotificationStatus | undefined =>
  notificationStatuses.find((status) => status === type);

// O card fala do evento, não do estado atual da sessão, então o texto é o da
// notificação e não o rótulo de status usado nas tabelas.
export const notificationTitles: Record<NotificationStatus, string> = {
  consent_approved: 'Acesso delegado aprovado',
  consent_rejected: 'Acesso delegado negado',
  consent_expiring: 'Solicitação de acesso prestes a expirar',
  approval_expiring: 'Aprovação prestes a expirar',
  consent_expired: 'Solicitação de acesso expirada',
  approval_expired: 'Aprovação expirada',
  session_ended_timeout: 'Sessão encerrada por tempo limite',
  session_ended_inactivity: 'Sessão encerrada por inatividade',
};

export const notificationSeverities: Record<
  NotificationStatus,
  NotificationSeverity
> = {
  consent_approved: 'success',
  consent_rejected: 'error',
  consent_expiring: 'warning',
  approval_expiring: 'warning',
  consent_expired: 'warning',
  approval_expired: 'error',
  session_ended_timeout: 'info',
  session_ended_inactivity: 'info',
};
